// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3QSJb","icon":"style_icon__2Xfwc"};